export default __webpack_public_path__ + "static/media/opo.9ea8dc51.gif";